module.exports = __webpack_public_path__ + "media/images/logos/visa-f63b4a7f9511cdc2ef3e6a75dc500dbf.svg";